import React from 'react';

import { Table } from '@devexpress/dx-react-grid-material-ui';
import ActionCell from './ActionCell';
import CustomRuleCell from './CustomRuleCell';
import EnabledStateCell from './EnabledStateCell';
import NameCell from './NameCell';
import RuleStatusCell from './RuleStatusCell';

import defaultClasses from './RulesTable.module.css';

function CellRenderer(cellProps) {
    let Component;
    switch (cellProps.column.name) {
        case 'action':
            Component = ActionCell;
            break;
        case 'custom':
            Component = CustomRuleCell;
            break;
        case 'enabled':
            Component = EnabledStateCell;
            break;
        case 'name':
            Component = NameCell;
            break;
        case 'status':
            Component = RuleStatusCell;
            break;
        default:
            Component = Table.Cell;
    }
    return (
        <Component {...cellProps} className={defaultClasses.cell} />
    );
}

export default CellRenderer;
